import request from '@/service/request';

export const getCustomersList = (data: any) => {
  return request.get('/v1/agency-platform-vn-v2/agency/customers', {
    params: data,
  });
};

export const getCustomersPoliciesList = (data: any) => {
  return request(`/v1/agency-platform-vn-v2/agency/policies`, { params: data });
};

export const repay = (data: any) => {
  return request.post(
    '/v1/agency-platform-vn-v2/agency/policies/:id/repay'.replace(
      ':id',
      data.display_id,
    ),
    { data },
  );
};

export const getPolicyDetailByQuoteId = (data: any) => {
  return request.get(
    '/v1/agency-platform-vn-v2/agency/policy?quote_id=' + data.quote_id,
  );
};

export const getPoliciesDetail = (data: any) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/policies/:id`.replace(':id', data.id),
  );
};

export const getPolicyDetailConfig = (data: any) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${data.product_type}/products/${data.product_key}/plans/${data.plan_key}/application_config`,
  );
};
